import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }

  delayedClose(event) {
    const eventElement = event.currentTarget
    const modal = eventElement.closest('[role="dialog"]')

    const closeButton = modal.querySelector('[data-pc-name="pcclosebutton"]')

    // NOTE: need to look into this and check the selector
    const popupCloseButton = document.querySelector('.popup-content button')

    if (closeButton) {
      setTimeout(() => {
        if (closeButton) {
          closeButton.click()
        }

        if (popupCloseButton) {
          popupCloseButton.click()
        }
      }, 200)
    }
  }
}